! function(t) {
    "use strict";
    var i = function(i) {
        var e = this;
        e.o = {
            source: "locations.json",
            selector: "[id^=landmark] > *",
            landmark: !1,
            mapfill: !1,
            height: 420,
            markers: !0,
            minimap: !0,
            sidebar: !0,
            search: !0,
            deeplinking: !0,
            clearbutton: !0,
            zoombuttons: !0,
            zoomoutclose: !1,
            action: "tooltip",
            lightbox: !1,
            hovertip: !0,
            smartip: !0,
            fillcolor: "#4d5e6d",
            fullscreen: !0,
            developer: !1,
            mousewheel: !0,
            alphabetic: !1,
            maxscale: 3,
            zoom: !0
        }, e.el = i, e.init = function(i) {
            return e.o = t.extend(e.o, i), e.el.addClass("mapplic-element mapplic-loading").height(e.o.height), "string" == typeof e.o.source ? t.getJSON(e.o.source, function(t) {
                a(t), e.el.removeClass("mapplic-loading")
            }).fail(function() {
                console.error("Couldn't load map data. (Make sure to run the script through web server)"), e.el.removeClass("mapplic-loading").addClass("mapplic-error"), alert("Data file missing or invalid!\nMake sure to run the script through web server.")
            }) : (a(e.o.source), e.el.removeClass("mapplic-loading")), e
        };
        var a = function(i) {
                e.data = i;
                var a = null;
                e.o.landmark = e.el.data("landmark"), e.o.landmark && (e.o.sidebar = !1, e.o.zoombuttons = !1, e.o.deeplinking = !1), e.container = t("<div></div>").addClass("mapplic-container").appendTo(e.el), e.map = t("<div></div>").addClass("mapplic-map").appendTo(e.container), e.o.zoom && e.map.addClass("mapplic-zoomable"), e.levelselect = t("<select></select>").addClass("mapplic-levels-select"), e.contentWidth = parseFloat(i.mapwidth), e.contentHeight = parseFloat(i.mapheight), e.o.minimap && (e.minimap = new function() {
                    this.el = null, this.opacity = null, this.init = function() {
                        this.el = t("<div></div>").addClass("mapplic-minimap").appendTo(e.container), this.el.click(function(i) {
                            i.preventDefault();
                            var a = (i.pageX - t(this).offset().left) / t(this).width(),
                                o = (i.pageY - t(this).offset().top) / t(this).height();
                            e.moveTo(a, o, e.scale / e.fitscale, 100)
                        })
                    }, this.addLayer = function(i) {
                        var e = t("<div></div>").addClass("mapplic-minimap-layer").attr("data-floor", i.id).appendTo(this.el),
                            a = this;
                        t("<img>").attr("src", i.minimap).addClass("mapplic-minimap-background").appendTo(e), t("<div></div>").addClass("mapplic-minimap-overlay").appendTo(e), t("<img>").attr("src", i.minimap).addClass("mapplic-minimap-active").on("load", function() {
                            a.update(), t(this).addClass("mapplic-clip-transition")
                        }).appendTo(e)
                    }, this.show = function(i) {
                        t(".mapplic-minimap-layer", this.el).hide(), t('.mapplic-minimap-layer[data-floor="' + i + '"]', this.el).show()
                    }, this.update = function(i, a) {
                        var o = t(".mapplic-minimap-active", this.el);
                        void 0 === i && (i = e.x), void 0 === a && (a = e.y);
                        var n = Math.round(e.container.width() / e.contentWidth / e.scale * this.el.width()),
                            l = Math.round(e.container.height() / e.contentHeight / e.scale * this.el.height()),
                            s = Math.round(-a / e.contentHeight / e.scale * this.el.height()),
                            c = Math.round(-i / e.contentWidth / e.scale * this.el.width()),
                            p = c + n,
                            h = s + l;
                        o.each(function() {
                            t(this)[0].style.clip = "rect(" + s + "px, " + p + "px, " + h + "px, " + c + "px)"
                        });
                        var d = this;
                        this.el.show(), this.el.css("opacity", 1), clearTimeout(this.opacity), this.opacity = setTimeout(function() {
                            d.el.css("opacity", 0), setTimeout(function() {
                                d.el.hide()
                            }, 600)
                        }, 2e3)
                    }
                }, e.minimap.init()), e.o.sidebar ? (e.sidebar = new function() {
                    this.el = null, this.list = null, this.init = function() {
                        var i = this;
                        if (this.el = t("<div></div>").addClass("mapplic-sidebar").appendTo(e.el), e.o.search) {
                            var a = t("<form></form>").addClass("mapplic-search-form").submit(function() {
                                return !1
                            }).appendTo(this.el);
                            e.clear = t("<button></button>").attr("type", "button").addClass("mapplic-search-clear").click(function() {
                                o.val(""), o.keyup()
                            }).appendTo(a);
                            var o = t("<input isp_ignore>").attr({
                                type: "text",
                                spellcheck: "false",
                                placeholder: "Buscar Tienda..."
                            }).addClass("mapplic-search-input").keyup(function() {
                                var e = t(this).val();
                                i.search(e)
                            }).prependTo(a)
                        }
                        var n = t("<div></div>").addClass("mapplic-list-container").appendTo(this.el);
                        this.list = t("<ol></ol>").addClass("mapplic-list").appendTo(n), this.notfound = t("<p></p>").addClass("mapplic-not-found").text("Intenta con otro nombre.").appendTo(n), e.o.search || n.css("padding-top", "0")
                    }, this.addCategories = function(i) {
                        var e = this.list;
                        i && t.each(i, function(i, a) {
                            var o = t("<li></li>").addClass("mapplic-list-category").attr("data-category", a.id),
                                n = t("<ol></ol>").css("border-color", a.color).appendTo(o);
                            "false" == a.show ? n.hide() : o.addClass("mapplic-opened");
                            var l = t("<a></a>").attr("href", "#").attr("title", a.title).css("background-color", a.color).text(a.title).prependTo(o);
                            l.on("click", function(t) {
                                t.preventDefault(), o.toggleClass("mapplic-opened"), n.slideToggle(200)
                            }), a.icon && t("<img>").attr("src", a.icon).addClass("mapplic-list-thumbnail").prependTo(l), t("<span></span>").text("0").addClass("mapplic-list-count").prependTo(l), e.append(o)
                        })
                    }, this.addLocation = function(i) {
                        var a = t("<li></li>").addClass("mapplic-list-location").addClass("mapplic-list-shown").attr("data-location", i.id),
                            o = t("<a></a>").attr("href", "#").click(function(a) {
                                a.preventDefault(), e.showLocation(i.id, 600), t(window).width() < 668 && t("html, body").animate({
                                    scrollTop: e.container.offset().top
                                }, 400)
                            }).appendTo(a);
                        i.thumbnail && t("<img>").attr("src", i.thumbnail).addClass("mapplic-list-thumbnail").appendTo(o), t("<h4></h4>").text(i.title).appendTo(o), t("<span></span>").html(i.about).appendTo(o);
                        var n = t('.mapplic-list-category[data-category="' + i.category + '"]');
                        n.length ? t("ol", n).append(a) : this.list.append(a), t(".mapplic-list-count", n).text(t(".mapplic-list-shown", n).length)
                    }, this.search = function(i) {
                        i ? e.clear.fadeIn(100) : e.clear.fadeOut(100), t(".mapplic-list li", e.el).each(function() {
                            t(this).text().search(new RegExp(i, "i")) < 0 ? (t(this).removeClass("mapplic-list-shown"), t(this).slideUp(200)) : (t(this).addClass("mapplic-list-shown"), t(this).show())
                        }), t(".mapplic-list > li", e.el).each(function() {
                            var i = t(".mapplic-list-shown", this).length;
                            t(".mapplic-list-count", this).text(i)
                        }), t(".mapplic-list > li.mapplic-list-shown").length > 0 ? this.notfound.fadeOut(200) : this.notfound.fadeIn(200)
                    }
                }, e.sidebar.init(), e.sidebar.addCategories(i.categories)) : e.container.css("width", "100%");
                var l = 0;
                if (i.levels && t.each(i.levels, function(i, o) {
                        var s = o.map,
                            c = s.substr(s.lastIndexOf(".") + 1).toLowerCase(),
                            p = t("<div></div>").addClass("mapplic-layer").attr("data-floor", o.id).hide().appendTo(e.map);
                        switch (c) {
                            case "jpg":
                            case "jpeg":
                            case "png":
                            case "gif":
                                t("<img>").attr("src", s).addClass("mapplic-map-image").appendTo(p);
                                break;
                            case "svg":
                                t("<div></div>").addClass("mapplic-map-image").load(s, function() {
                                    t(e.o.selector, this).each(function() {
                                        var i = e.getLocationData(t(this).attr("id"));
                                        if (i) {
                                            t(this).attr("class", "mapplic-clickable"), i.el = t(this);
                                            var a = null;
                                            i.fill ? a = i.fill : e.o.fillcolor && (a = e.o.fillcolor), a && (t(this).css("fill", a), t("> *", this).css("fill", a)), e.o.landmark === i.id && t(this).attr("class", "mapplic-active")
                                        }
                                    }), t(e.o.selector, this).on("click touchend", function() {
                                        e.dragging || e.showLocation(t(this).attr("id"), 600)
                                    }), t("svg a", this).each(function() {
                                        var i = e.getLocationData(t(this).attr("xlink:href").substr(1));
                                        i && (t(this).attr("class", "mapplic-clickable"), i.el = t(this))
                                    }), t("svg a", this).click(function(i) {
                                        var a = t(this).attr("xlink:href").substr(1);
                                        e.showLocation(a, 600), i.preventDefault()
                                    })
                                }).appendTo(p);
                                break;
                            default:
                                alert("File type " + c + " is not supported!")
                        }
                        e.minimap && e.minimap.addLayer(o), e.levelselect.prepend(t("<option></option>").attr("value", o.id).text(o.title)), a && !o.show || (a = o.id), t.each(o.locations, function(i, a) {
                            if (a.lat && a.lng) {
                                var o = n(a.lat, a.lng);
                                a.x = o.x, a.y = o.y
                            }
                            var l = 100 * a.y,
                                s = 100 * a.x;
                            if (a.pin || (a.pin = "default"), -1 == a.pin.indexOf("hidden") && e.o.markers) {
                                var c = t("<a></a>").attr("href", "#").addClass("mapplic-pin").css({
                                    top: l + "%",
                                    left: s + "%"
                                }).appendTo(p);
                                c.on("click touchend", function(t) {
                                    t.preventDefault(), e.showLocation(a.id, 600)
                                }), a.label && c.html(a.label), a.fill && c.css("background-color", a.fill), c.attr("data-location", a.id), c.addClass(a.pin), a.el = c
                            }
                            e.sidebar && e.sidebar.addLocation(a)
                        }), l++
                    }), e.tooltip = (new function() {
                        this.el = null, this.pin = null, this.shift = 6, this.drop = 0, this.location = null, this.tooltipthumb = !0, this.tooltiplink = !0, this.init = function() {
                            return this.el = t("<div></div>").addClass("mapplic-tooltip"), this.close = t("<a></a>").addClass("mapplic-tooltip-close").attr("href", "#").appendTo(this.el), this.close.on("click touchend", function(t) {
                                t.preventDefault(), e.hideLocation(), e.o.zoom && !e.o.zoomoutclose || e.moveTo(.5, .5, e.fitscale, 400, "easeInOutCubic")
                            }), this.tooltipthumb && (this.thumbnail = t("<img>").addClass("mapplic-tooltip-thumbnail").hide().appendTo(this.el)), this.content = t("<div></div>").addClass("mapplic-tooltip-content").appendTo(this.el), this.title = t("<h4></h4>").addClass("mapplic-tooltip-title").appendTo(this.content), this.desc = t("<div></div>").addClass("mapplic-tooltip-description").appendTo(this.content), this.tooltiplink && (this.link = t("<a>Ver Tienda</a>").addClass("mapplic-popup-link").attr("href", "#").hide().appendTo(this.el)), this.triangle = t("<div></div>").addClass("mapplic-tooltip-triangle").prependTo(this.el), e.map.append(this.el), this
                        }, this.show = function(i) {
                            if (i) {
                                var a = this;
                                this.location = i, e.hovertip && e.hovertip.hide(), this.tooltipthumb && (i.thumbnail ? this.thumbnail.attr("src", i.thumbnail).show() : this.thumbnail.hide()), this.tooltiplink && (i.link ? this.link.attr("href", i.link).show() : this.link.hide()), this.title.text(i.title), i.description ? this.desc.html(i.description) : this.desc.empty(), this.content[0].scrollTop = 0, this.pin = t('.mapplic-pin[data-location="' + i.id + '"]'), 0 == this.pin.length ? this.shift = 20 : this.shift = Math.abs(parseFloat(this.pin.css("margin-top"))) + 20, t("img", this.el).off("load").on("load", function() {
                                    a.position(), a.zoom(i)
                                }), this.position(), this.el.stop().show(), this.zoom(i)
                            }
                        }, this.position = function() {
                            if (this.location) {
                                var t = e.map.offset().left + e.map.width() * this.location.x - e.container.offset().left,
                                    i = e.map.offset().top + e.map.height() * this.location.y - e.container.offset().top,
                                    a = 100 * this.location.x,
                                    o = 100 * this.location.y,
                                    n = -this.el.outerHeight() - this.shift,
                                    l = -this.el.outerWidth() / 2;
                                if (e.o.smartip) {
                                    var s = .5;
                                    Math.abs(n) > i ? (n = 10, this.pin && this.pin.length && (n = this.pin.height() + parseFloat(this.pin.css("margin-top")) + 20), this.el.addClass("mapplic-bottom")) : this.el.removeClass("mapplic-bottom"), this.el.outerWidth() / 2 > t ? s = .5 - (this.el.outerWidth() / 2 - t) / this.el.outerWidth() : e.container.width() - t - this.el.outerWidth() / 2 < 0 && (s = .5 + (t + this.el.outerWidth() / 2 - e.container.width()) / this.el.outerWidth()), s = Math.max(0, Math.min(1, s)), l = -this.el.outerWidth() * s, this.triangle.css("left", Math.max(5, Math.min(95, 100 * s)) + "%")
                                }
                                this.el.css({
                                    left: a + "%",
                                    top: o + "%",
                                    marginTop: n,
                                    marginLeft: l
                                }), this.drop = this.el.outerHeight() + this.shift
                            }
                        }, this.zoom = function(t) {
                            var i, a = t.zoom ? parseFloat(t.zoom) : e.o.maxscale;
                            i = ((e.container.height() - this.drop) / 2 + this.drop) / e.container.height(), e.moveTo(t.x, t.y, a, 600, "easeInOutCubic", i)
                        }, this.hide = function() {
                            var t = this;
                            this.location = null, this.el.stop().fadeOut(300, function() {
                                t.desc && t.desc.empty()
                            })
                        }
                    }).init(), e.o.lightbox && (e.lightbox = (new function() {
                        this.el = null, this.init = function() {
                            return this.el = t("<div></div>").addClass("mapplic-lightbox mfp-hide"), this.title = t("<h2></h2>").addClass("mapplic-lightbox-title").appendTo(this.el), this.desc = t("<div></div>").addClass("mapplic-lightbox-description").appendTo(this.el), this.link = t("<a>More</a>").addClass("mapplic-popup-link").attr("href", "#").hide().appendTo(this.el), t("body").magnificPopup({
                                delegate: ".mapplic-popup-image",
                                type: "image",
                                removalDelay: 300,
                                mainClass: "mfp-fade"
                            }), e.el.append(this.el), this
                        }, this.show = function(i) {
                            this.location = i, this.title.text(i.title), this.desc.html(i.description), i.link ? this.link.attr("href", i.link).show() : this.link.hide();
                            var a = this;
                            t.magnificPopup.open({
                                items: {
                                    src: this.el
                                },
                                type: "inline",
                                removalDelay: 300,
                                mainClass: "mfp-fade",
                                callbacks: {
                                    beforeClose: function() {
                                        a.hide()
                                    }
                                }
                            });
                            var o = i.zoom ? parseFloat(i.zoom) : e.o.maxscale;
                            e.moveTo(i.x, i.y, o, 600, "easeInOutCubic"), e.tooltip && e.tooltip.hide()
                        }, this.hide = function() {
                            this.location = null, e.hideLocation(), e.o.zoom && !e.o.zoomoutclose || e.moveTo(.5, .5, e.fitscale, 400, "easeInOutCubic")
                        }
                    }).init()), e.o.hovertip && (e.hovertip = (new function() {
                        this.el = null, this.pin = null, this.shift = 6, this.hovertipdesc = !1, this.init = function() {
                            var i = this;
                            return this.el = t("<div></div>").addClass("mapplic-tooltip mapplic-hovertip"), this.title = t("<h4></h4>").addClass("mapplic-tooltip-title").appendTo(this.el), this.hovertipdesc && (this.desc = t("<div></div>").addClass("mapplic-tooltip-description").appendTo(this.el)), this.triangle = t("<div></div>").addClass("mapplic-tooltip-triangle").appendTo(this.el), t(e.map).on("mouseover", ".mapplic-layer a", function() {
                                var a = "";
                                t(this).hasClass("mapplic-pin") ? (a = t(this).data("location"), i.pin = t('.mapplic-pin[data-location="' + a + '"]'), i.shift = Math.abs(parseFloat(i.pin.css("margin-top"))) + 20) : (a = t(this).attr("xlink:href").slice(1), i.shift = 20);
                                var o = e.getLocationData(a);
                                o && i.show(o)
                            }).on("mouseout", function() {
                                i.hide()
                            }), e.o.selector && t(e.map).on("mouseover", e.o.selector, function() {
                                var a = e.getLocationData(t(this).attr("id"));
                                i.shift = 20, a && i.show(a)
                            }).on("mouseout", function() {
                                i.hide()
                            }), e.map.append(this.el), this
                        }, this.show = function(t) {
                            e.tooltip.location != t && (this.title.text(t.title), this.hovertipdesc && this.desc.html(t.description), this.position(t), this.el.stop().fadeIn(100))
                        }, this.position = function(t) {
                            var i, a = e.map.offset().left + e.map.width() * t.x - e.container.offset().left,
                                o = e.map.offset().top + e.map.height() * t.y - e.container.offset().top,
                                n = 100 * t.x,
                                l = 100 * t.y,
                                s = -this.el.outerHeight() - this.shift,
                                c = .5;
                            Math.abs(s) > o ? (s = 10, this.pin && this.pin.length && (s = this.pin.height() + parseFloat(this.pin.css("margin-top")) + 20), this.el.addClass("mapplic-bottom")) : this.el.removeClass("mapplic-bottom"), this.el.outerWidth() / 2 > a ? c = .5 - (this.el.outerWidth() / 2 - a) / this.el.outerWidth() : e.container.width() - a - this.el.outerWidth() / 2 < 0 && (c = .5 + (a + this.el.outerWidth() / 2 - e.container.width()) / this.el.outerWidth()), i = -this.el.outerWidth() * c, this.triangle.css("left", Math.max(10, Math.min(90, 100 * c)) + "%"), this.el.css({
                                left: n + "%",
                                top: l + "%",
                                marginTop: s,
                                marginLeft: i
                            })
                        }, this.hide = function() {
                            this.el.stop().fadeOut(200)
                        }
                    }).init()), e.o.clearbutton && (e.clearbutton = (new function() {
                        this.el = null, this.init = function() {
                            return this.el = t("<a></a>").attr("href", "#").addClass("mapplic-clear-button").appendTo(e.container), this.el.on("click touchstart", function(t) {
                                t.preventDefault(), e.hideLocation(), e.moveTo(.5, .5, e.fitscale, 400, "easeInOutCubic")
                            }), this
                        }
                    }).init()), e.o.zoombuttons && (e.zoombuttons = (new function() {
                        this.el = null, this.init = function() {
                            return this.el = t("<div></div>").addClass("mapplic-zoom-buttons").appendTo(e.container), e.o.clearbutton || this.el.css("bottom", "0"), this.zoomin = t("<a></ha>").attr("href", "#").addClass("mapplic-zoomin-button").appendTo(this.el), this.zoomin.on("click touchstart", function(t) {
                                t.preventDefault();
                                var i = e.scale;
                                e.scale = h(i + .8 * i), e.x = c(e.x - (e.container.width() / 2 - e.x) * (e.scale / i - 1)), e.y = p(e.y - (e.container.height() / 2 - e.y) * (e.scale / i - 1)), d(e.x, e.y, e.scale, 400, "easeInOutCubic")
                            }), this.zoomout = t("<a></ha>").attr("href", "#").addClass("mapplic-zoomout-button").appendTo(this.el), this.zoomout.on("click touchstart", function(t) {
                                t.preventDefault();
                                var i = e.scale;
                                e.scale = h(i - .4 * i), e.x = c(e.x - (e.container.width() / 2 - e.x) * (e.scale / i - 1)), e.y = p(e.y - (e.container.height() / 2 - e.y) * (e.scale / i - 1)), d(e.x, e.y, e.scale, 400, "easeInOutCubic")
                            }), this
                        }, this.update = function(t) {
                            this.zoomin.removeClass("mapplic-disabled"), this.zoomout.removeClass("mapplic-disabled"), t == e.fitscale ? this.zoomout.addClass("mapplic-disabled") : t == e.o.maxscale && this.zoomin.addClass("mapplic-disabled")
                        }
                    }).init()), e.o.fullscreen && (e.fullscreen = (new function() {
                        this.el = null, this.init = function() {
                            t("<a></a>").attr("href", "#").attr("href", "#").addClass("mapplic-fullscreen-button").click(function(i) {
                                i.preventDefault(), e.el.toggleClass("mapplic-fullscreen"), t(document).resize()
                            }).appendTo(e.container), t(document).keyup(function(i) {
                                27 === i.keyCode && (t(".mapplic-element.mapplic-fullscreen").removeClass("mapplic-fullscreen"), t(document).resize())
                            })
                        }
                    }).init()), e.o.developer && (e.devtools = (new function() {
                        this.el = null, this.init = function() {
                            return this.el = t("<div></div>").addClass("mapplic-coordinates").appendTo(e.container), this.el.append("x: "), t("<code></code>").addClass("mapplic-coordinates-x").appendTo(this.el), this.el.append(" y: "), t("<code></code>").addClass("mapplic-coordinates-y").appendTo(this.el), t(".mapplic-layer", e.map).on("mousemove", function(i) {
                                var a = (i.pageX - e.map.offset().left) / e.map.width(),
                                    o = (i.pageY - e.map.offset().top) / e.map.height();
                                t(".mapplic-coordinates-x").text(parseFloat(a).toFixed(4)), t(".mapplic-coordinates-y").text(parseFloat(o).toFixed(4))
                            }), this
                        }
                    }).init()), console.log(e.devtools), l > 1) {
                    e.levels = t("<div></div>").addClass("mapplic-levels");
                    var s = t('<a href="#"></a>').addClass("mapplic-levels-up").appendTo(e.levels);
                    e.levelselect.appendTo(e.levels);
                    var r = t('<a href="#"></a>').addClass("mapplic-levels-down").appendTo(e.levels);
                    e.container.append(e.levels), e.levelselect.change(function() {
                        var i = t(this).val();
                        e.switchLevel(i)
                    }), s.click(function(i) {
                        i.preventDefault(), t(this).hasClass("mapplic-disabled") || e.switchLevel("+")
                    }), r.click(function(i) {
                        i.preventDefault(), t(this).hasClass("mapplic-disabled") || e.switchLevel("-")
                    })
                }
                if (e.switchLevel(a), t(window).resize(function() {
                        if (t(window).width() < 668)
                            if (e.el.hasClass("mapplic-fullscreen")) e.container.height(t(window).height());
                            else {
                                var i = Math.min(Math.max(e.container.width() * e.contentHeight / e.contentWidth, 2 * t(window).height() / 3), t(window).height() - 66);
                                e.container.height(i)
                            }
                        else e.container.height("100%");
                        var a = e.container.width() / e.contentWidth,
                            o = e.container.height() / e.contentHeight;
                        e.o.mapfill ? e.fitscale = a > o ? a : o : e.fitscale = a < o ? a : o, e.scale = h(e.scale), e.x = c(e.x), e.y = p(e.y), d(e.x, e.y, e.scale, 0)
                    }).resize(), e.o.landmark) e.showLocation(e.o.landmark, 0);
                else {
                    var m = e.getLocationData("init");
                    m ? e.moveTo(m.x, m.y, parseFloat(m.zoom), 0) : e.moveTo(.5, .5, e.fitscale, 0)
                }
                e.o.deeplinking && (history.pushState ? e.deeplinking = new function() {
                    this.param = "location", this.init = function() {
                        var t = this;
                        this.check(0), window.onpopstate = function(i) {
                            return i.state && t.check(600), !1
                        }
                    }, this.check = function(t) {
                        var i = this.getUrlParam(this.param);
                        e.showLocation(i, t, !0)
                    }, this.getUrlParam = function(t) {
                        t = t.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
                        var i = new RegExp("[\\?&]" + t + "=([^&#]*)").exec(location.search);
                        return null === i ? "" : decodeURIComponent(i[1].replace(/\+/g, " "))
                    }, this.update = function(t) {
                        var i = window.location.protocol + "//" + window.location.host + window.location.pathname + "?" + this.param + "=" + t;
                        window.history.pushState({
                            path: i
                        }, "", i)
                    }, this.clear = function() {
                        history.pushState("", document.title, window.location.pathname)
                    }
                } : e.deeplinking = new function() {
                    this.param = "location", this.init = function() {
                        var i = this;
                        this.check(0), t(window).on("hashchange", function() {
                            i.check(600)
                        })
                    }, this.check = function(t) {
                        var i = location.hash.slice(this.param.length + 2);
                        e.showLocation(i, t, !0)
                    }, this.update = function(t) {
                        window.location.hash = this.param + "-" + t
                    }, this.clear = function() {
                        window.location.hash = this.param
                    }
                }, e.deeplinking.init()), e.el.trigger("mapready", e), e.o.zoom && o()
            },
            o = function() {
                var i = e.map,
                    a = t(".mapplic-map-image", e.map);
                if (document.ondragstart = function() {
                        return !1
                    }, a.on("mousedown", function(a) {
                        e.dragging = !1, i.data("mouseX", a.pageX), i.data("mouseY", a.pageY), i.is(":animated") && (i.stop(), e.x = c(i.offset().left - e.container.offset().left), e.y = p(i.offset().top - e.container.offset().top), e.scale = h(i.width() / e.contentWidth)), i.addClass("mapplic-dragging"), e.map.on("mousemove", function(t) {
                            e.dragging = !0;
                            var a = t.pageX - i.data("mouseX") + e.x,
                                o = t.pageY - i.data("mouseY") + e.y;
                            a = c(a), o = p(o), d(a, o), i.data("lastX", a), i.data("lastY", o)
                        }), t(document).on("mouseup", function() {
                            e.x = i.data("lastX"), e.y = i.data("lastY"), e.map.off("mousemove"), t(document).off("mouseup"), i.removeClass("mapplic-dragging")
                        })
                    }), e.el.on("dblclick", ".mapplic-map-image", function(t) {
                        t.preventDefault();
                        var i = e.scale;
                        e.scale = h(2 * i), e.x = c(e.x - (t.pageX - e.container.offset().left - e.x) * (e.scale / i - 1)), e.y = p(e.y - (t.pageY - e.container.offset().top - e.y) * (e.scale / i - 1)), d(e.x, e.y, e.scale, 400, "easeInOutCubic")
                    }), e.o.mousewheel && t(".mapplic-layer", e.el).bind("mousewheel DOMMouseScroll", function(t, i) {
                        var a = e.scale;
                        e.scale = h(a + a * i / 5), t.preventDefault(), e.x = c(e.x - (t.pageX - e.container.offset().left - e.x) * (e.scale / a - 1)), e.y = p(e.y - (t.pageY - e.container.offset().top - e.y) * (e.scale / a - 1)), d(e.x, e.y, e.scale, 200, "easeOutCubic")
                    }), !("ontouchstart" in window || "onmsgesturechange" in window)) return !0;
                a.on("touchstart", function(t) {
                    e.dragging = !1;
                    var o = t.originalEvent,
                        n = i.position();
                    i.data("touchY", o.changedTouches[0].pageY - n.top), i.data("touchX", o.changedTouches[0].pageX - n.left), a.on("touchmove", function(t) {
                        t.preventDefault(), e.dragging = !0;
                        var o = t.originalEvent;
                        1 == o.touches.length ? (e.x = c(o.changedTouches[0].pageX - i.data("touchX")), e.y = p(o.changedTouches[0].pageY - i.data("touchY")), d(e.x, e.y, e.scale, 50)) : a.off("touchmove")
                    }), a.on("touchend", function(t) {
                        a.off("touchmove touchend")
                    })
                });
                var o = new Hammer(e.map[0], {
                    transform_always_block: !0,
                    drag_block_horizontal: !0,
                    drag_block_vertical: !0
                });
                o.get("pinch").set({
                    enable: !0
                });
                var n, l = 1;
                o.on("pinchstart", function(t) {
                    e.dragging = !1, l = e.scale / e.fitscale, n = l
                }), o.on("pinch", function(t) {
                    e.dragging = !0, 1 != t.scale && (l = Math.max(1, Math.min(n * t.scale, 100)));
                    var i = e.scale;
                    e.scale = h(l * e.fitscale), e.x = c(e.x - (t.center.x - e.container.offset().left - e.x) * (e.scale / i - 1)), e.y = p(e.y - (t.center.y - e.y) * (e.scale / i - 1)), d(e.x, e.y, e.scale, 100)
                })
            },
            n = function(t, i) {
                var a = e.data.rightLng - e.data.leftLng,
                    o = e.data.bottomLat * Math.PI / 180,
                    n = e.data.mapwidth / a * 360 / (2 * Math.PI),
                    l = n / 2 * Math.log((1 + Math.sin(o)) / (1 - Math.sin(o)));
                return t = t * Math.PI / 180, {
                    x: (i - e.data.leftLng) * (e.data.mapwidth / a) / e.data.mapwidth,
                    y: (e.data.mapheight - (n / 2 * Math.log((1 + Math.sin(t)) / (1 - Math.sin(t))) - l)) / e.data.mapheight
                }
            },
            l = function(t, i) {
                var e = t.attr("class"); - 1 == e.indexOf(i) && t.attr("class", e + " " + i)
            },
            s = function(t, i) {
                var e = t.attr("class");
                e && t.attr("class", e.replace(i, "").trim())
            },
            c = function(t) {
                var i = e.container.width() - e.contentWidth * e.scale;
                return i < 0 ? t > 0 ? t = 0 : t < i && (t = i) : t = i / 2, t
            },
            p = function(t) {
                var i = e.container.height() - e.contentHeight * e.scale;
                return i < 0 ? t >= 0 ? t = 0 : t < i && (t = i) : t = i / 2, t
            },
            h = function(t) {
                return t < e.fitscale ? t = e.fitscale : t > e.o.maxscale && (t = e.o.maxscale), e.zoombuttons && e.zoombuttons.update(t), t
            },
            d = function(t, i, a, o, n) {
                void 0 !== a ? e.map.stop().animate({
                    left: t,
                    top: i,
                    width: e.contentWidth * a,
                    height: e.contentHeight * a
                }, o, n, function() {
                    e.tooltip && e.tooltip.position()
                }) : e.map.css({
                    left: t,
                    top: i
                }), e.tooltip && e.tooltip.position(), e.minimap && e.minimap.update(t, i), e.el.trigger("positionchanged", location)
            };
        e.switchLevel = function(i) {
            switch (i) {
                case "+":
                    i = t("option:selected", e.levelselect).removeAttr("selected").prev().prop("selected", "selected").val();
                    break;
                case "-":
                    i = t("option:selected", e.levelselect).removeAttr("selected").next().prop("selected", "selected").val();
                    break;
                default:
                    t('option[value="' + i + '"]', e.levelselect).prop("selected", "selected")
            }
            if (i) {
                var a = t('.mapplic-layer[data-floor="' + i + '"]', e.el);
                if (!a.is(":visible")) {
                    e.tooltip && e.tooltip.hide(), t(".mapplic-layer:visible", e.map).hide(), a.show(), e.minimap && e.minimap.show(i);
                    var o = e.levelselect.get(0).selectedIndex,
                        n = t(".mapplic-levels-up", e.el),
                        l = t(".mapplic-levels-down", e.el);
                    n.removeClass("mapplic-disabled"), l.removeClass("mapplic-disabled"), 0 == o ? n.addClass("mapplic-disabled") : o == e.levelselect.get(0).length - 1 && l.addClass("mapplic-disabled"), e.el.trigger("levelswitched", i)
                }
            }
        }, e.moveTo = function(t, i, a, o, n, l) {
            o = void 0 !== o ? o : 400, l = void 0 !== l ? l : .5, a = void 0 !== a ? a : e.scale / e.fitscale, e.scale = h(a), e.x = c(.5 * e.container.width() - e.scale * e.contentWidth * t), e.y = p(e.container.height() * l - e.scale * e.contentHeight * i), d(e.x, e.y, e.scale, o, n)
        }, e.getLocationData = function(i) {
            var a = null;
            return t.each(e.data.levels, function(e, o) {
                t.each(o.locations, function(t, e) {
                    e.id == i && (a = e)
                })
            }), a
        }, e.showLocation = function(i, a, o) {
            t.each(e.data.levels, function(a, n) {
                if (n.id == i) return e.switchLevel(n.id), !1;
                t.each(n.locations, function(a, c) {
                    if (c.id == i) {
                        switch (c.action && "default" != c.action ? c.action : e.o.action) {
                            case "open-link":
                                return window.location.href = c.link, !1;
                            case "open-link-new-tab":
                                return window.open(c.link), !1;
                            case "select":
                                return c.el && (h = c.el, d = "mapplic-active", h.attr("class").indexOf(d) > -1 ? s(c.el, "mapplic-active") : l(c.el, "mapplic-active")), !1;
                            case "none":
                                var p = c.zoom ? parseFloat(c.zoom) : e.o.maxscale;
                                e.switchLevel(n.id), e.moveTo(c.x, c.y, p, 600, "easeInOutCubic");
                                break;
                            case "lightbox":
                                e.switchLevel(n.id), e.lightbox.show(c);
                                break;
                            default:
                                e.switchLevel(n.id), e.tooltip.show(c)
                        }
                        s(t(".mapplic-active", e.el), "mapplic-active"), c.el && l(c.el, "mapplic-active"), e.deeplinking && !o && e.deeplinking.update(i), e.el.trigger("locationopened", c)
                    }
                    var h, d
                })
            })
        }, e.hideLocation = function() {
            s(t(".mapplic-active", e.el), "mapplic-active"), e.deeplinking && e.deeplinking.clear(), e.tooltip && e.tooltip.hide(), e.el.trigger("locationclosed")
        }, e.updateLocation = function(t) {
            var i = e.getLocationData(t);
            if (i.id == t && i.el.is("a")) {
                if (i.lat && i.lng) {
                    var a = n(i.lat, i.lng);
                    i.x = a.x, i.y = a.y
                }
                var o = 100 * i.y,
                    l = 100 * i.x;
                i.el.css({
                    top: o + "%",
                    left: l + "%"
                })
            }
        }
    };
    t.extend(t.easing, {
        def: "easeOutQuad",
        swing: function(t, i, e, a, o) {
            return jQuery.easing[jQuery.easing.def](t, i, e, a, o)
        },
        easeOutQuad: function(t, i, e, a, o) {
            return -a * (i /= o) * (i - 2) + e
        },
        easeOutCubic: function(t, i, e, a, o) {
            return a * ((i = i / o - 1) * i * i + 1) + e
        },
        easeInOutCubic: function(t, i, e, a, o) {
            return (i /= o / 2) < 1 ? a / 2 * i * i * i + e : a / 2 * ((i -= 2) * i * i + 2) + e
        }
    }), t.fn.mapplic = function(e) {
        return this.each(function() {
            var a = t(this);
            if (!a.data("mapplic")) {
                var o = new i(a).init(e);
                a.data("mapplic", o)
            }
        })
    }
}(jQuery);